import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, EventEmitter, Output, OnDestroy, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime,distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-table-filter-search',
    templateUrl: './table-filter-search.component.html',
    styleUrls: ['./table-filter-search.component.scss'],
    standalone: false
})
export class TableFilterSearchComponent implements OnInit,OnChanges,AfterViewInit,OnDestroy {
  @Input() objPosition : any;
  @Input() searchLabel : any;
  @Input() columnRowData = [];
  @Output() searchKeyword = new EventEmitter();
  @Output() closeFilterOverlay = new EventEmitter();
  @Input() columnRowDataBackup = [];
  @ViewChild('tableFilter', { static: false }) tableFilter: ElementRef;
  elm: HTMLElement;
  queryField: UntypedFormControl = new UntypedFormControl();

  optionList = [];
  searchTermList = [];
  backupOptionList = [];
  constructor(private el: ElementRef) { }

  ngOnChanges() {
    this.getOptionListData();
  }
 
  ngAfterViewInit(): void {
    document.body.appendChild(this.el.nativeElement);
  }

  ngOnInit(): void {
    this.searchData();
  }
  searchData(){
    this.queryField.valueChanges
    .pipe(
      // debounceTime(100),
      distinctUntilChanged()
    )
    .subscribe( result =>{ 
      // this.searchKeyword.emit(result)

      if(result){
        this.optionList = this.backupOptionList.filter(x => x.label.toLowerCase().includes(result.toLowerCase()));
      } else{
        this.optionList = [...this.backupOptionList];
      }
    });
  }

  closeFilter(){
    this.closeFilterOverlay.emit('');
  }

  getOptionListData(){
    console.log(this.searchLabel);
    const optionsListData = [...new Set(this.columnRowData.map(el => el[this.searchLabel['id']]))];
    this.optionList = [...this.setOptionListData(optionsListData)];
    this.backupOptionList = [...this.optionList];
    console.log("backupOptionList ", this.backupOptionList);
  }

  setOptionListData(optionsListData){
    let arrData = [];
    optionsListData.forEach(data => {
      let opt = {};
      if(data){
        opt['label']=data;
        opt['isSelected'] = false;
        arrData.push(opt);
      }
    });
    return arrData;
  }

  searchApply(){
    if(this.searchTermList.length){
      console.log("SER ", this.searchTermList);
      this.searchKeyword.emit(this.searchTermList)
    } else{
      this.closeFilter();
    }
  }

  setSearchValue(e){
     if(e.target.checked){
      let index = this.searchTermList.findIndex(x => x === e.target.value);
      if(index == -1){
        this.searchTermList.push(e.target.value)
        console.log("this.searchTermList add ", this.searchTermList)

      }
    } else{
      let index = this.searchTermList.findIndex(x => x === e.target.value);
      console.log("CALLED ", index)

      if(index > -1){
        this.searchTermList.splice(index,1);
        console.log("this.searchTermList re ", this.searchTermList)

      }
    }
  }
  selectDeselectAll(e){
    if(e.target.checked){
      this.searchTermList = [];
      this.optionList.forEach(data => {
         data.isSelected = true;
         this.searchTermList.push(data.label);
      });
    } else{
      this.searchTermList = [];
      this.optionList.forEach(data => {
        data.isSelected = false;
     });
    }
  }
  ngOnDestroy(): void {
    this.el.nativeElement.remove();
  }

}
